import { ID } from "../core/id";

export enum WorkStatus {
  DO = "do", // В работе
  CORRECT = "correct", // Исправить
  WAIT_CHEACK = "wait_cheack", // На проверке
  WAIT_PAY = "wait_pay", // Скоро оплатим
  CLOSE = "close", // Выполнен
  TIME_WORK_OFF = "time_work_off", // Время на выполнение вышло
  TIME_CHEACK_OFF = "time_cheack_off", // Время на проверку вышло
  DELETE_OFF = "delete_off", // Отзыв найден, но был удалён
  UNSET_ADMIN = "unset_admin", // Снято админом
  UNSET_PAY = "unset_pay", // Снято после оплаты
  UNSET_USER = "unset_user", // Снято исполнителем
  UNSET_DUPLICATE = "unset_duplicate", // Копия
  UNSET_SCORE = "unset_score", // Нет оценки
}

export interface Work {
  id: ID;
  job_id: ID;
  executor_id: ID;
  status: WorkStatus;
  price: number;
  nickname?: string;
  image?: string;
  text?: string;
  step: number;
  date_modified: number;
  date_published: number;
  time: WorkTime;
}
export interface WorkView extends Work {
  correct?: WorkCorrect;
}
export interface WorkTime {
  date_start?: number; // Время начала работы
  date_working?: number; // Время отправки работы
  date_unset?: number; // Время отправки работы
  date_review?: number; // Время проверки
  date_complite?: number; // Время выполнения
}

/// =================
/// Правки работы
/// =================
export enum WorkCorrectCause {
  EDIT_TEXT = "edit_text",
  EDIT_TEXT_AI = "edit_text_ai",
  NO_FOTO = "no_foto",
  BAD_NAME = "bad_name",
}

export interface WorkCorrect {
  id: ID;
  work_id: ID;
  cause: WorkCorrectCause;
  client_comment: string;
  executor_comment: string;
  is_ready: boolean;
  date_modified: number;
  date_published: number;
}
export const WORK_CORRECT_CAUSE_NAMES: Record<WorkCorrectCause, string> = {
  [WorkCorrectCause.EDIT_TEXT]: "Исправить текст",
  [WorkCorrectCause.EDIT_TEXT_AI]: "Исправить текст (AI)",
  [WorkCorrectCause.NO_FOTO]: "Добавить фото",
  [WorkCorrectCause.BAD_NAME]: "Исправить имя",
};
